/* WEB-07 (24-oct-2026) · Mini carrito nuevo, como el prototipo.
   - Barra de envío gratis sobre lo que se paga con transferencia (regla: $65.000 ya con el 25%).
   - Cada prenda: precio transferencia + precio con tarjeta, − cantidad +, Quitar. Foto según Calce/Plana.
   - Sugeridos: más vendidos que no están en el carrito, ordenados según el cliente (ver pick()), eligiendo talle ahí mismo.
   - Pagar con transferencia / tarjeta: mismos caminos que el carrito de antes.
   Se abre con la bolsa y cada vez que algo se agrega al carrito (reemplaza al carrito lateral del theme). */
(() => {
  const ENVIO = 65000;
  const root = document.getElementById('W7Cart');
  if (!root) return;
  const env = root.querySelector('.w7-cp-env');
  const body = root.querySelector('.w7-cp-body');
  const foot = root.querySelector('.w7-cp-foot');
  const title = root.querySelector('.w7-cp-top b');
  let data = null;
  let busy = false;

  const $m = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-AR');
  const tr = (cents) => Math.round(cents * 0.75);
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const plana = () => document.querySelector('.w7-foto[open]') !== null || (() => {
    try { return Object.keys(localStorage).some((k) => k.endsWith(':model-view') && localStorage.getItem(k) === 'true'); } catch (e) { return false; }
  })();
  const foto = (o) => (plana() ? o.plana || o.calce : o.calce || o.plana) || '';

  const load = async () => {
    const r = await fetch('/?sections=w7-cart-data', { headers: { Accept: 'application/json' } });
    const j = await r.json();
    const html = j['w7-cart-data'] || '';
    const m = html.match(/<script[^>]*data-w7-cart[^>]*>([\s\S]*?)<\/script>/);
    data = m ? JSON.parse(m[1]) : { count: 0, items: [], ups: [] };
    document.querySelectorAll('cart-count').forEach((c) => { c.textContent = data.count; c.hidden = !data.count; });
    draw();
  };

  // Sugeridos personalizados (25-oct): se ordenan según lo que lleva y mira el cliente.
  //  1) Para quién: Mujer/Hombre del interruptor del menú o de lo que hay en el carrito (Unisex sirve a los dos).
  //  2) «Con esta llegás»: si con esa prenda alcanza el envío gratis (la más barata que alcanza, primero).
  //  3) Su talle: el que más se repite en el carrito, si no el del filtro de talle que usó. Agrega directo ese talle.
  //  4) La miró hace poco (buscador · «Visto recién»), y que combine (otro grupo que lo que ya lleva).
  const ls = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  try {
    const q = new URLSearchParams(location.search).getAll('filter.v.option.talle');
    if (q.length === 1) localStorage.setItem('w7:talle', q[0]);
  } catch (e) {}
  const arr = (v) => (Array.isArray(v) ? v : v ? [v] : []);
  const pick = (items, falta) => {
    const cnt = (xs) => xs.reduce((m, x) => (x ? (m[x] = (m[x] || 0) + 1, m) : m), {});
    const top = (m) => Object.keys(m).sort((a, b) => m[b] - m[a])[0] || '';
    const gen = ls('w7:gen') || top(cnt(items.flatMap((i) => arr(i.para).filter((p) => p !== 'Unisex'))));
    const talle = top(cnt(items.map((i) => i.talle))) || ls('w7:talle') || '';
    const grupos = new Set(items.map((i) => i.grupo).filter(Boolean));
    let vistos = [];
    try { vistos = JSON.parse(ls('w7:vistos') || '[]').map((v) => v.url); } catch (e) {}
    const conQue = (g) => (items.find((i) => i.grupo && i.grupo !== g) || {}).title || '';
    const cand = (data.ups || []).filter((u) => u.sizes && u.sizes.length).map((u, idx) => {
      const para = arr(u.para);
      if (gen && para.length && !para.includes(gen) && !para.includes('Unisex')) return null;
      const reach = falta > 0 && tr(u.unit) >= falta;
      const mine = talle ? u.sizes.find((s) => String(s.t).toLowerCase() === talle.toLowerCase()) : null;
      const visto = vistos.some((v) => u.url.indexOf(v) === 0);
      const combina = grupos.size && u.grupo && !grupos.has(u.grupo);
      let s = -idx * 0.5;
      if (reach) s += 30 - tr(u.unit) / 500000;
      if (mine) s += 12; else if (talle) s -= 8;
      if (visto) s += 8;
      if (combina) s += 6;
      const tag = reach ? '✓ Llegás' : visto ? 'La miraste' : combina && conQue(u.grupo) ? 'Combina con tu ' + conQue(u.grupo) : '';
      return { ...u, reach, mine, tag, s };
    }).filter(Boolean).sort((a, b) => b.s - a.s).slice(0, 4);
    const head = cand.some((u) => u.reach) ? 'Con una de estas llegás al envío gratis'
      : falta > 0 ? 'Sumá un básico · te faltan ' + $m(falta)
      : 'Combina con lo que llevás';
    return { list: cand, head };
  };

  const draw = () => {
    const items = data.items || [];
    const n = data.count || 0;
    const lista = items.reduce((a, i) => a + i.line, 0);
    const neto = items.reduce((a, i) => a + tr(i.unit) * i.qty, 0);
    title.textContent = 'Tu carrito' + (n ? ` (${n})` : '');

    if (!n) {
      env.hidden = true;
      foot.hidden = true;
      body.innerHTML = '<p class="w7-cp-vacio">Tu carrito está vacío.<br>Sumá una prenda desde el catálogo.</p>';
      return;
    }

    const falta = ENVIO * 100 - neto;
    const pct = Math.min(100, (neto / (ENVIO * 100)) * 100);
    env.hidden = false;
    env.className = 'w7-cp-env' + (falta <= 0 ? ' ok' : '');
    env.innerHTML = (falta > 0
      ? `Te faltan <b>${$m(falta)}</b> para el <b>envío gratis a sucursal</b> <span class="w7-cp-env-s">(pagando por transferencia)</span>`
      : '<b>¡Tenés envío gratis a sucursal!</b>') + `<div class="w7-cp-bar"><i style="width:${pct}%"></i></div>`;

    const lines = items.map((i, k) => `
      <div class="w7-cp-it${i.forced ? ' is-forced' : ''}">
        <a class="w7-cp-ph" href="${esc(i.url)}"><img alt="" loading="lazy" src="${esc(foto(i))}"></a>
        <div>
          <a class="w7-cp-nm" href="${esc(i.url)}">${esc(i.title)}</a>
          <div class="w7-cp-vr">${esc((i.options || []).join(' · ') || i.variant)}</div>
          ${i.forced ? '<div class="w7-cp-err">Ya no está disponible: quitala para poder pagar.</div>' : ''}
          <div class="w7-cp-pr"><b>${$m(tr(i.unit) * i.qty)}</b> transferencia</div>
          <div class="w7-cp-pr2">${$m(i.line)} con tarjeta</div>
          <div class="w7-cp-row">
            <div class="w7-qty" role="group" aria-label="Cantidad">
              <button type="button" data-q="${k}" data-d="-1" aria-label="Restar">−</button><span>${i.qty}</span><button type="button" data-q="${k}" data-d="1" aria-label="Sumar">+</button>
            </div>
            <button type="button" class="w7-cp-rm" data-rm="${k}">Quitar</button>
          </div>
        </div>
      </div>`).join('');

    const sug = pick(items, falta);
    const ups = sug.list;
    const upsHtml = ups.length ? `
      <div class="w7-cp-up">
        <p class="w7-cp-h">${esc(sug.head)}</p>
        <div class="w7-cp-ups">${ups.map((u, k) => `
          <div class="w7-cp-u">
            <a class="w7-cp-ph" href="${esc(u.url)}"><img alt="" loading="lazy" src="${esc(foto(u))}">${u.tag ? `<span class="w7-cp-tag${u.reach ? ' ok' : ''}">${esc(u.tag)}</span>` : ''}</a>
            <div class="w7-cp-unm">${esc(u.title)}</div>
            <div class="w7-cp-upr"><b>${$m(tr(u.unit))}</b>${u.color ? ` · ${esc(u.color)}` : ''}</div>
            ${u.mine
              ? `<button type="button" class="w7-cp-add" data-add="${u.mine.id}">+ Agregar ${esc(u.mine.t)}</button>`
              : `<button type="button" class="w7-cp-add" data-up="${k}">+ Agregar</button>
            <div class="w7-cp-sz" data-sz="${k}" hidden>${u.sizes.map((s) => `<button type="button" data-add="${s.id}">${esc(s.t)}</button>`).join('')}</div>`}
          </div>`).join('')}
        </div>
      </div>` : '';
    // 25-oct: los sugeridos van arriba, pegados a la barra de envío gratis (la barra dice cuánto falta y abajo, con qué llegás)
    body.innerHTML = upsHtml + lines;

    foot.hidden = false;
    foot.innerHTML = `
      <div class="w7-cp-tot"><span>Total por transferencia</span><b>${$m(neto)}</b></div>
      <div class="w7-cp-ah">Ahorrás ${$m(lista - neto)} · 25% ya aplicado</div>
      ${data.forced ? '<div class="w7-cp-err">Uno de los productos ya no está disponible. Quitalo para poder pagar.</div>' : `
      <a class="w7-cp-pay" href="/discount/DELIVER?redirect=%2Fcheckout" data-no-instant>Pagar con transferencia · ${$m(neto)}</a>
      <button class="w7-cp-card" type="submit" name="checkout">Pagar con tarjeta o Mercado Pago · ${$m(lista)}<small>6 cuotas sin interés de ${$m(lista / 6)}</small></button>`}
      <div class="w7-cp-links"><button type="button" data-dlvr-compartir-cart>Compartir mi carrito</button></div>`;
  };

  const change = async (key, quantity) => {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      await load();
    } finally { busy = false; root.classList.remove('is-busy'); }
  };
  const add = async (id) => {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    try {
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
      await load();
    } finally { busy = false; root.classList.remove('is-busy'); }
  };

  root.addEventListener('click', (e) => {
    const q = e.target.closest('[data-q]');
    if (q) { const i = data.items[+q.dataset.q]; change(i.key, Math.max(0, i.qty + Number(q.dataset.d))); return; }
    const rm = e.target.closest('[data-rm]');
    if (rm) { change(data.items[+rm.dataset.rm].key, 0); return; }
    const up = e.target.closest('[data-up]');
    if (up) { up.hidden = true; root.querySelector(`[data-sz="${up.dataset.up}"]`).hidden = false; return; }
    const a = e.target.closest('[data-add]');
    if (a) { add(a.dataset.add); return; }
    const card = e.target.closest('.w7-cp-card');
    if (card && window.dlvrPayCard && window.dlvrPayCard(card) === false) e.preventDefault();
  });
  root.addEventListener('w7:open', () => load().catch(() => {}));

  // Los «Agregar al carrito» del theme abren su carrito lateral: lo cerramos y abrimos este.
  const themeDrawer = document.getElementById('CartDrawer');
  if (themeDrawer) {
    // 26-oct: la 6.1 abre su carrito con el atributo «active» (la 5.3 usaba «open») → se miran los dos
    new MutationObserver(() => {
      if (!themeDrawer.hasAttribute('open') && !themeDrawer.hasAttribute('active')) return;
      if (typeof themeDrawer.hide === 'function') { try { themeDrawer.hide(); } catch (e) {} }
      themeDrawer.removeAttribute('open'); themeDrawer.removeAttribute('active');
      window.w7Panel && window.w7Panel.open('W7Cart');
    }).observe(themeDrawer, { attributes: true, attributeFilter: ['open', 'active'] });
  }
  // 26-oct (Alan, opción a): un solo carrito. La página /cart abre este mismo panel (misma cuenta del envío gratis,
  // mismo diseño) y al cerrarlo vuelve a la página anterior. El /cart viejo queda escondido debajo.
  if (/^\/cart\/?$/.test(location.pathname)) {
    document.documentElement.classList.add('w7-cartpage');
    const abrir = () => { if (window.w7Panel) window.w7Panel.open('W7Cart'); else setTimeout(abrir, 100); };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', abrir) : abrir();
    new MutationObserver(() => {
      if (root.classList.contains('in')) return;
      setTimeout(() => {
        if (root.classList.contains('in')) return;
        const ref = document.referrer && new URL(document.referrer).origin === location.origin && !/\/cart/.test(document.referrer);
        if (ref) history.back(); else location.href = '/';
      }, 320);
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }
  // Si algo cambia el carrito con el panel abierto (otra pestaña de la página), se actualiza.
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const p = _fetch.apply(this, args);
    const url = String(args[0] && args[0].url ? args[0].url : args[0] || '');
    if (/\/cart\/(add|change|update|clear)/.test(url) && !root.hidden && !busy) p.then(() => setTimeout(() => load().catch(() => {}), 300));
    return p;
  };
})();
